import React from "react";
// import signatureImg from "../../../../../../Assets/assetsnew/signature-symbol.svg";
import TextStyles from "../../../../../../Constants/TextStyles";
import Styled from "./SignatureStyles";

import signatureImage from "../../../../../../Assets/assetsnew/newSignature.svg"

const Signature = ({
  selectedData,
  data,
  businessInfoData,
  primaryContact,
}) => {
  return (
    <Styled.ReviewBox className="my-4">
      <TextStyles.FontSize18px className="d-flex gap-2 gap-md-3 align-items-center">
        <img src={signatureImage} alt="signature icon" width={35} />
        <span className="fw-medium">Signature</span>
      </TextStyles.FontSize18px>

      <div className="d-sm-flex justify-content-between">
        <div>
          <div
            style={{
              fontWeight: 400,
              fontSize: 36,
              height: 130,
            }}
            className="align-content-end"
          >
              {selectedData &&
                selectedData.client_signature &&
                selectedData.client_signature.text && (
                  <div style={{ fontFamily: "licorice" }}>
                    {selectedData.client_signature.text}
                  </div>
                )}
              {selectedData &&
                selectedData.client_signature &&
                selectedData.client_signature.image &&
                selectedData.client_signature.image.image_name && (
                  <img
                    src={selectedData.client_signature.image.image_url}
                    alt="imageBtn"
                    style={{ maxHeight: 120, maxWidth: 200 }}
                  />
                )}
          </div>

          <TextStyles.FontSize16px>
            {selectedData &&
              selectedData.client_id &&
              selectedData.client_id.company_name}
          </TextStyles.FontSize16px>

          <TextStyles.GreyFont14px>
            {primaryContact && primaryContact.contact_name}
          </TextStyles.GreyFont14px>
        </div>

        <div className="text-end">
          <div
            style={{
              fontWeight: 400,
              fontSize: 36,
              height: 130,
            }}
            className="align-content-end"
          >
              {selectedData &&
                selectedData.signature &&
                selectedData.signature.text && (
                  <div style={{ fontFamily: "licorice" }}>
                    {selectedData.signature.text}
                  </div>
                )}

              {selectedData &&
                selectedData.signature &&
                selectedData.signature.image &&
                selectedData.signature.image.image_name && (
                  <img
                    src={selectedData.signature.image.image_url}
                    alt="imageBtn"
                    style={{ maxHeight: 120, maxWidth: 200 }}
                    className="mt-3 mt-sm-0"
                  />
                )}
          </div>

          <TextStyles.FontSize16px>
            {businessInfoData && businessInfoData.business_name
              ? businessInfoData.business_name
              : data && `${data.firstName} ${data.lastName}`}
          </TextStyles.FontSize16px>

          <TextStyles.GreyFont14px>
            {businessInfoData &&
            businessInfoData.business_name !==
              `${data.firstName} ${data.lastName}`
              ? data && `${data.firstName} ${data.lastName}`
              : ""}
          </TextStyles.GreyFont14px>
        </div>
      </div>
    </Styled.ReviewBox>
  );
};

export default Signature;
